import { REQUEST_STATUS } from './constants';
import { REQUEST_STATUS_DATA as BASE_DATA } from '../user/glossary';

export const REQUEST_STATUS_DATA = {
  [REQUEST_STATUS.new]: {
    ...BASE_DATA[REQUEST_STATUS.new],
  },
  [REQUEST_STATUS.accepted]: {
    ...BASE_DATA[REQUEST_STATUS.accepted],
  },
  [REQUEST_STATUS.rejected]: {
    ...BASE_DATA[REQUEST_STATUS.rejected],
  },
};

export default {
  REQUEST_STATUS_DATA,
};
